/* eslint-disable no-unused-vars */
import FormGroup from './fields/formGroup'

/**
 * Creates an instance of FormDefinition.
 * @typedef {Object} FormDefinitionType
 * @property {FormGroup[]} groups - An array of form groups.
 * @property {Object} pdfConfiguration - The optional pdf configuration associated with the form definition.
 */

/**
 * Represents the definition of a form.
 * @class
 */
export default class FormDefinition {
  /**
   * Create a new FormSchema.
   * @param {FormDefinitionType} params
   */
  constructor(params) {
    this.groups =
      params.groups.length > 0
        ? params.groups.map((group) => new FormGroup(group))
        : []
    this.hasPdfConfiguration = !!params.pdfConfiguration
  }
}
